import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";
import { api, errMsg, todayISO } from "@/lib/api";
import { PatientFields, emptyPatient, cleanPatient } from "@/components/patient/PatientFields";

export function PatientFormDialog({ open, onOpenChange, onCreated }) {
  const [form, setForm] = useState(emptyPatient());
  const [invite, setInvite] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setForm({ ...emptyPatient(), first_visit_date: todayISO() });
  }, [open]);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.post(`/patients?send_invite=${invite && !!form.email}`, cleanPatient(form));
      toast.success("Paziente creato", { description: data.invite_sent ? "Email di accesso inviata" : undefined });
      onOpenChange(false);
      onCreated?.(data);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto rounded-2xl" data-testid="patient-form-dialog">
        <DialogHeader><DialogTitle>Nuovo paziente</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-5">
          <PatientFields form={form} setForm={setForm} />
          <div className="flex items-center justify-between rounded-xl bg-[#edf2ef] px-4 py-3">
            <div>
              <div className="text-sm font-semibold text-[#2f4f47]">Crea accesso area personale</div>
              <div className="text-xs text-slate-500">Il paziente riceverà un'email per impostare la password</div>
            </div>
            <Switch checked={invite} onCheckedChange={setInvite} data-testid="patient-form-invite-switch" />
          </div>
          <div className="flex justify-end">
            <button className="btn-primary" disabled={saving} data-testid="patient-form-submit">{saving ? "Salvataggio…" : "Crea scheda paziente"}</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
